<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/farmerTab.jpg" alt="" ref="info">
            <div class="banner-container">
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <div style="color: red;">咨询电话：187 6642 6120</div>
                <div class="detail-main-text" ref="case">
                    农民工工资支付保证保险，是指由保险公司向工程项目所在地建设行政主管部门提供的保证工程项目所在地的施工承包人按规定支付建筑工人员工工资的保险。<br />
                    主要保障投保人在出现不履行工资发放义务，拖欠、克扣农民工工资并经建设行政主管部门和/或人力资源和社会保障部门认定的，给被保险人造成经济损失，保险人负责赔偿。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>项目</th>
                                <th>内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>投保人</td>
                                <td>依法从事各类新建、扩建、改建工程的建设单位和施工承包单位</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>被保险人</td>
                                <td>建设单位和施工承包单位依法招用的有劳动关系的农民工</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>项目信息</td>
                                <td>项目名称：按照合同中的项目名称为准<br />工程造价：按照合同中的合同总价为准
                                </td>
                            </tr>
                            <tr class="hoverTr">
                                <td>优势</td>
                                <td>可有效替代现金保证金，极大释放企业资金</td>
                            </tr>
                            <tr class="hoverTr" ref="question">
                                <td>保险金额</td>
                                <td>合同中要求缴纳的农民工工资支付保证金金额</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保费</td>
                                <td>保险金额*保险费率（保险费率百1-百2）</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、企业为什么要买农民工工资支付保证保险？</b></p>
                    <p>
                        答：《保障农民工工资支付条例》规定，施工总承包单位应当按照有关规定存储工资保证金或办理金融机构保函，专项用于支付为所承包工程提供劳动的农民工被拖欠的工资。施工总承包单位未按规定存储工资保证金或未提供金融机构保函，将受到严厉的行政处罚，包括罚款、项目停工、限制承接新工程、降低资质等级、吊销资质证书等处罚。<br />
                        农名工工资支付保证保险是国家政策明文支持的创新支付保证金代替形式，具有费用成本低、手续资料少、办理方便快捷等特点。
                    </p>
                    <p><b>2、为何选择我们投保？</b></p>
                    <p>答：成本优势：费率可低至百1，盘活企业保证金99 %<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;办理优势：办理便捷，不占授信，当天投保当天出单。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;服务优势：全流程管家服务，链接保险机构，协助快速出单。
                    </p>
                    <p><b>3、如何投保？</b></p>
                    <p >答：提供营业执照，施工合同，上一年度财务审计报告，人社局下发缴纳保证金通知函，企业施工资质证明后获取精准保险方案，并由服务人员协助完成投保。</p>
                    <p><b>4、能举例说明下农民工保险的用处吗？</b></p>
                    <p>案例：某道路施工项目，施工方需缴纳300万的农民工工资支付保证金，由于现金保证金数额较大，且传统保函申请门槛较高、手续办理繁琐，施工方希望投保一份农民工工资支付保证保险。</p>
                    <p ref="claim">
                        据此为其制定投保方案：<br />
                        ● 保额即赔偿限额300万元<br />
                        ● 保险费率百1.5%<br />
                        ● 保费合计4.5万元<br />
                        ● 盘活企业应缴现金工资保证金多达295.5万元
                    </p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        
        <div class="detail allDet detail-main-text">
             <p>
                <b>请添加以下微信进行询价</b>
             </p>
            <img src="../../../images/code.png"  style="width: 20%;margin-top: 15px;" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                let url = '/haierProduct.html#/customized-employer-liability/fillin';
                if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                else url += `?productCode=QYTTGZZRXPCNEW`
                location.href = url
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/farmer.vue